import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import debug from '../../services/debug';
import App from '../app/container';

interface RedirectRouterProps {
  handleSetContactRedirectRoute: (command: string | undefined) => void;
}

function RedirectRouter({
  handleSetContactRedirectRoute,
}: RedirectRouterProps) {
  const { command } = useParams();

  debug('redirect command', command);

  useEffect(() => {
    handleSetContactRedirectRoute(command);
  }, []);

  return <App />;
}

export default RedirectRouter;
